(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-featured-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll("[data-swatches]").forEach(block => {
  const colorList = block.dataset.swatches.trim();
  if (!colorList) return;

  const colors = colorList.split(',');
  const container = block.querySelector('.swatches');

  colors.forEach(color => {
    const div = document.createElement('div');
    div.className = "swatch";
    div.style.background = color.trim();
    container.appendChild(div);
  });
});

  } catch(e) { console.error(e); }
})();
})();
